import { array, func, object } from "prop-types";
import { ChatItem } from "react-chat-elements";
import { formatImage } from "../../utils/formatImage";

ConversationsList.propTypes = {
    chats: array,
    onClickChat: func,
    selectedChat: object,
};
export default function ConversationsList({ chats, onClickChat, selectedChat }) {
    const toRender = chats.map((chat) => ({
        ...chat,
        avatar: formatImage(chat.image, { w: 72, h: 72 }),
        alt: chat.name,
        title: chat.name,
        subtitle: chat.lastMessage,
        date: chat.lastUpdate ? new Date(chat.lastUpdate.toMillis()) : new Date(),
        onClick: () => onClickChat(chat),
        className: chat.id === selectedChat?.id ? 'selected' : '',
    }));

    return (
        <div style={styles.chatListContainer}>
            <div style={{ flex: 1, width: '100%', height: '100%' }}>
                <div className="chat-list" style={styles.chatList}>
                    {
                        toRender.map((chat) => ( <ChatItem key={chat.id} {...chat} />))
                    }
                </div>
            </div>
        </div>
    );
}

const styles = {
    chatListContainer: {
        display: 'flex',
        alignItems: 'row',
        position: 'absolute',
        width: '100%',
        height: '100%',
        marginRight: 8,
        backgroundColor: '#ededed',
    },
    chatList: {
        height: '100%'
    }
}